/* eslint-disable object-curly-newline */
/* eslint-disable import/prefer-default-export */

import api from 'services';
import {
  customerCreationPayload,
  customerResponse,
  customerValidationDetail,
  responseFullCustomer,
  responseModelCustomer,
} from 'interfaces/Customer';
import { listQueryParams } from 'interfaces/Proposal';

const path = '/customer';

export const getCustomerList = async (payload: listQueryParams): Promise<responseModelCustomer> => {
  const response = await api.get<responseModelCustomer>(`${path}/list`, { params: payload });
  return response.data;
};

export const getFullCustomerByID = async (id: number): Promise<responseFullCustomer> => {
  const response = await api.get<responseFullCustomer>(`${path}/${id}`);
  return response.data;
};

export const getValidCustomer = async (cpf: string): Promise<customerValidationDetail> => {
  const response = await api.get<customerValidationDetail>(`${path}/validCustomer/${cpf}`);
  return response.data;
};

export const postCustomer = async (payload: customerCreationPayload): Promise<customerResponse> => {
  const response = await api.post<customerResponse>(`${path}/create`, payload);
  return response.data;
};
